import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MobileWebViewService } from '../../../../../core/services/mobile-web-view.service';
import { GeneralService } from '../../../../../core/services/general.service';
import { ModalOptionsConfig, ModalService } from '../../../../../lean-shared/components/nz-modal-service/modal.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { CountdownType } from '../../../otp-count-down/otp-count-down.component';

@Component({
	selector: 'app-mobile-device-registration',
	templateUrl: './mobile-device-registration.component.html',
	styleUrls: ['./mobile-device-registration.component.scss'],
})
export class MobileDeviceRegistrationComponent implements OnInit {
	@Input() ussdCode: any;
	@Input() submitting;
	@Input() expiryTime: any;
	@Output() emitSubmit = new EventEmitter();
	countdownType = CountdownType;
	pin: string;
	disableButton: boolean;

	devices = [
		{
			name: 'Samsung Galaxy 10',
			os: 'Android Nugiant',
			manufacturer: 'ANDRIOD',
		},
		{
			name: 'Iphone 13',
			os: 'ios 15',
			manufacturer: 'IOS',
		},
	];
	runningModal: NzModalRef;

	constructor(private webViewService: MobileWebViewService, private generalService: GeneralService, private modalService: ModalService) {}

	ngOnInit(): void {}

	onInputChange($event: string) {
		this.pin = $event;
		this.disableButton = $event.length === 6;
	}

	submit() {
		this.emitSubmit.emit(this.pin);
	}

	goBack() {
		this.generalService.logout();
	}

	retryOtp() {
		this.goBack();
	}

	openReplaceDeviceModal(device) {
		const params = {
			replaceDeviceName: device,
			deviceName: 'Iphone 13 pro Max',
		};
	}

	launchModal(params, component) {
		const config = this.createModalConfig(params);
		this.runningModal = this.modalService.createModal(component, config);
	}

	createModalConfig(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.data = params;
		config.className = 'moniepoint-dialog';
		config.nzComponentParams.callback = (result) => {
			this.handleOncloseModal(result);
		};
		return config;
	}

	handleOncloseModal(params) {
		if (this.runningModal) {
			this.runningModal.destroy();
		}
	}
}
